import { api } from '../api/client';
import type { CareForm, FormField } from './types/form.types';

/** Como a API grava: os campos ficam em versões, e a resposta cita a versão que foi respondida. */
interface FormularioGravado {
  id: string;
  title: string;
  description?: string;
  chapeu?: string | null;
  textoDoBotao?: string | null;
  versions?: Array<{ version: number; fields?: FormField[] }>;
}

/**
 * A versão mais recente, achatada no formato que o formulário desenha (A127).
 * Sem isto o app recebia `versions` e procurava `fields`: o modal abria só com
 * o botão de enviar, e a resposta saía sempre como versão 1. O mobile antigo
 * faz a mesma conversão em `form.service.ts`.
 */
export function formularioDaVersaoAtual(gravado: FormularioGravado): CareForm {
  const atual = [...(gravado.versions ?? [])].sort((a, b) => b.version - a.version)[0];
  return {
    id: gravado.id,
    title: gravado.title,
    description: gravado.description,
    chapeu: gravado.chapeu ?? null,
    textoDoBotao: gravado.textoDoBotao ?? null,
    fields: atual?.fields ?? [],
    version: atual?.version ?? 1,
  };
}

export const formsApi = {
  get: async (formId: string) => formularioDaVersaoAtual(await api.get<FormularioGravado>(`/api/care-forms/${formId}`)),
  submit: (formId: string, formVersion: number, answers: Record<string, unknown>) => api.post<void>('/api/care-form-responses', { formId, formVersion, answers }),
};
